<!--
  Main Application Component Layout

  Structure:
  - Uses DevExtreme Box (dx-box) for vertical layout.
  - Applies 'cc-hidden' class when 'routeComplete' is false to control visibility.

  Content Rendering Logic:
  1. If the user is authenticated:
     a. If 'isOutletOnly' is true:
        - Renders a simple <router-outlet> for route content.
     b. Else:
        - If not on the login URL:
          - Renders the main application layout with <app-side-nav-outer-toolbar> and a <router-outlet>.
        - Else:
          - Falls through to the 'notAuthorized' template.
  2. If the user is not authenticated or on the login URL:
     - Renders a container with a background and a <router-outlet> for authentication-related routes.

  Additional Components:
  - <cc-message-box>: Displays global messages.
  - <app-dev-tools>: Developer tools for debugging.

  Templates:
  - 'notOutlet': Handles rendering when 'isOutletOnly' is false and not on the login URL.
  - 'notAuthorized': Handles rendering for unauthorized or login routes.
-->
<dx-box
  direction="col"
  width="100%"
  height="100%"
  [ngClass]="{ 'cc-hidden': !routeComplete }"
>
  <dxi-item [ratio]="1">
    <ng-container *ngIf="isAuthenticated; else notAuthorized">
      <ng-container *ngIf="isOutletOnly; else notOutlet">
        <router-outlet></router-outlet>
      </ng-container>
    </ng-container>
  </dxi-item>
</dx-box>

<ng-template #notOutlet>
  <ng-container *ngIf="!isLoginUrl(); else notAuthorized">
    <app-side-nav-outer-toolbar #appOuterSideNav [title]="title">
      <router-outlet (activate)="onActivate()"></router-outlet>
    </app-side-nav-outer-toolbar>
  </ng-container>
</ng-template>

<ng-template #notAuthorized>
  <div class="application-container cc-application-background">
    <router-outlet></router-outlet>
  </div>
</ng-template>

<cc-message-box #messageBox></cc-message-box>

<app-inactivity-warning-modal
  [(visible)]="showInactivityWarning"
  [timeoutMinutes]="inactivityTimeoutMinutes"
  (staySignedIn)="onStaySignedIn()"
></app-inactivity-warning-modal>

<app-dev-tools></app-dev-tools>

<app-survey-popup></app-survey-popup>

<cira-toast-container position="bottom-center"></cira-toast-container>
